import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const InTheFieldSection: React.FC = () => {
  return (
    <section
      className="spaq-field py-20 sm:py-24 lg:py-28 bg-[#FFFFFF] text-[#122331]"
      aria-labelledby="spaq-field-heading"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12">
        {/* Header with Title and All Cases Link */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 sm:mb-14">
          <div className="space-y-2">
            <span className="block text-xs font-bold tracking-[0.2em] text-[#526372] uppercase">
              IN THE FIELD
            </span>
            <h2
              id="spaq-field-heading"
              className="text-3xl sm:text-4xl font-bold text-[#122331] tracking-tight"
            >
              技術が働く、現場へ。
            </h2>
          </div>

          <Link
            to="/cases"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#087C96] hover:text-[#23A6C4] hover:underline transition-colors shrink-0 group"
          >
            <span>実績・事例を見る</span>
            <ArrowRight
              size={16}
              className="transition-transform group-hover:translate-x-1"
              aria-hidden="true"
            />
          </Link>
        </div>

        {/* 2-Column Field Showcase */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {/* Item A */}
          <Link
            to="/cases/manufacturing-plant-solar-design"
            className="group block text-left transition-opacity hover:opacity-95"
          >
            <div className="relative aspect-[16/9] w-full overflow-hidden bg-slate-100 rounded-sm">
              <img
                src="/assets/field/field-solar-mock.png"
                alt="工場・倉庫の屋根一面に設置された自家消費型太陽光パネル"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                width="600"
                height="338"
              />
              <span
                className="absolute bottom-2.5 left-2.5 px-2 py-0.5 text-[10px] text-white/90 bg-black/50 backdrop-blur-sm rounded-sm"
                aria-hidden="true"
              >
                写真イメージ
              </span>
            </div>
            <div className="mt-4 space-y-1.5">
              <h3 className="text-xl sm:text-2xl font-bold text-[#122331] group-hover:text-[#087C96] transition-colors">
                工場・倉庫の電力最適化
              </h3>
              <p className="text-sm text-[#526372] leading-relaxed">
                施設ごとに異なる電気の使い方に合わせて、最適な設備構成を設計。
              </p>
            </div>
          </Link>

          {/* Item B */}
          <Link
            to="/cases/cold-storage-simulation-model"
            className="group block text-left transition-opacity hover:opacity-95"
          >
            <div className="relative aspect-[16/9] w-full overflow-hidden bg-slate-100 rounded-sm">
              <img
                src="/assets/field/field-control-mock.png"
                alt="整然と設置された受変電設備・蓄電池および協調制御システム"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                width="600"
                height="338"
              />
              <span
                className="absolute bottom-2.5 left-2.5 px-2 py-0.5 text-[10px] text-white/90 bg-black/50 backdrop-blur-sm rounded-sm"
                aria-hidden="true"
              >
                写真イメージ
              </span>
            </div>
            <div className="mt-4 space-y-1.5">
              <h3 className="text-xl sm:text-2xl font-bold text-[#122331] group-hover:text-[#087C96] transition-colors">
                設備をつなぐ協調制御
              </h3>
              <p className="text-sm text-[#526372] leading-relaxed">
                太陽光・空調・蓄電池を連携させ、現場の電力の動きを最適化。
              </p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};
